import React, {Component} from 'react'

import Base from '../BaseComponent'
import {Form} from '../Forms'
import SingleInput from '../Forms/SingleInput'
import Grid from '../Grid'
import Link from '../Link'
import ActionLogger from '../ActionLogger';

import Jquery from 'jquery'

class Newsletter extends Component {

  constructor(props)
  {
    super(props)
    this.state = {
      selectedOption: '',
      name: '',
      email: '',
      isComplete: false
    }
  }

  isComplete = () => {
    if(this.state.selectedOption &&
      this.state.name &&
      this.state.email)
    {
      this.setState({isComplete:false})
    } else {
      this.setState({isComplete:true})
    }
  }

  handleOptionChange = (evt) => {
    this.setState({
      selectedOption: evt.target.value
    });
    this.isComplete();
  }

  handleNameChange = (evt) => {
    this.setState({
      name: evt.target.value
    });
    this.isComplete();
  }

  handleEmailChange = (evt) => {
    this.setState({
      email: evt.target.value
    });
    this.isComplete();
  }

  handleSubmit = (evt) => {
    evt.preventDefault();

    let {name,email,selectedOption} = this.state

    console.log(window.location.protocol,this.state)

    Jquery.post(window.location.protocol+'//thefenway.archivestud.io/subscribe/',{
      name: name,
      email: email,
      reason: selectedOption
    }, function(response)
    {
      if(response == 201)
            {
              window.location = '/thanks'
            }
    })
  }

  render () {

    const { email, name, selectedOption } = this.state
    const isEnabled =
          email.length > 0 &&
          name.length > 0 &&
          selectedOption.length > 0

    return (
      <Base {...this.props} family="Newsletter" >

      <form class="Form" onSubmit={this.handleSubmit}>

        <div className="Newsletter-grid">
          <Grid modifiers={['4','newsletter']}>

            <div className="Grid-item">

              <div className="Checkbox">
                <input type="radio" value="1" id="checkbox1"  name="reason" value="live" checked={this.state.selectedOption === 'live'} onChange={this.handleOptionChange} />
                <label for="checkbox1"></label>

                 <Link url={'#'} modifiers={['big']} title={'I live here'} />
              </div>




            </div>

            <div className="Grid-item">

              <div className="Checkbox">
                <input type="radio" value="1" id="checkbox2" name="reason" value="work" checked={this.state.selectedOption === 'work'} onChange={this.handleOptionChange} />
                <label for="checkbox2"></label>

                 <Link url={'#'} modifiers={['big']} title={'I work here'} />
              </div>

            </div>

            <div className="Grid-item">

              <div className="Checkbox">
                <input type="radio" value="1" id="checkbox3"  name="reason" value="visit" checked={this.state.selectedOption === 'visit'} onChange={this.handleOptionChange} />
                <label for="checkbox3"></label>

                 <Link url={'#'} modifiers={['big']} title={'I visit here'} />
              </div>

            </div>

            <div className="Grid-item">

              <div className="Checkbox">
                <input type="radio" value="1" id="checkbox4" name="reason" value="lost" checked={this.state.selectedOption === 'lost'} onChange={this.handleOptionChange} />
                <label for="checkbox4"></label>

                 <Link url={'#'} modifiers={['big']} title={'I got lost'} />
              </div>

            </div>

          </Grid>
        </div>

        <div className="Newsletter-form">
          <SingleInput className={'Form-input'} inputType={'text'} title={'Full Name'} name={'name'} placeholder={'Name:'} value={this.state.name} onChange={this.handleNameChange}/>
          <SingleInput className={'Form-input'} inputType={'text'} title={'Email'} name={'email'} placeholder={'Email Address:'} value={this.state.email} onChange={this.handleEmailChange} />
          <ActionLogger category={'Newsletter'} action={'Newsletter '+this.state.selectedOption} label={'Newsletter form submit: '+this.state.email}>
            <SingleInput className={'Form-submit'} inputType={'submit'} title={'Sign Up'} name={'Sign Up'} value={'Sign Up'} disabled={!isEnabled} />
          </ActionLogger>
        </div>

        </form>

      </Base>

    )
  }
}

export default Newsletter



// WEBPACK FOOTER //
// ./src/js/components/Newsletter/Newsletter.jsx